/* eslint-disable jsx-a11y/alt-text */
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router';
import styled from 'styled-components';
import { Colors } from '../../../../../common/colors/colors';
import {
	adminNavigationConfig,
	NAVIGATION_SECTION_PATH,
} from '../../../../../common/constants/navigationConfigs';
import Icon from '@/common/components/Icon';
import { slugify } from '@/common/helpers/slugify';
import { AuthContext } from '@/common/contexts/authContext';


const Wrapper = styled.div`
	background-color: #035072;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	border-radius: 0px 15px 15px 0px;
	height: 100vh;
	padding: 10px;
	width: 60px;
`;

const NavigationSection = styled(Link)`
	text-decoration: none;
	display: flex;
	align-items: center;
	font-size: 20px;
	font-weight: bold;
	gap: 15px;
	color: white;
	padding: 6px 15px;
	border-radius: 15px;

	${({ link }) =>
		link && `margin-bottom: 10px; &:hover {  transform: scale(1.1);}`}
	${({ selected }) => selected && ` background-color: ${Colors.lightBlue};  `} 
    
    
    &:hover .hover {
		display: block;
	}
`;

// const Icon = styled.i`
// 	font-size: 20px;
// 	color: white;
// `;

const IconWrapper = styled.div`
	width: 30px;
	display: flex;
	justify-content: center;
`;

const Box = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 80vh;
`;

const Hover = styled.div`
	display: none;
	position: absolute;
	background-color: lightgrey;
	color: ${Colors.darkBlue};
	border-radius: 15px;
	padding: 5px;
	font-size: 10px;
	margin-top: 50px;
	width: 80px;
	text-align: center;
	margin-left: -15px;
`;

const Navbar = () => {
	const { checkAccess } = useContext(AuthContext);

	const { pathname } = useLocation();

	const getSectionLink = (section) =>
		section.link ||
		`${NAVIGATION_SECTION_PATH}/${slugify(section.name)}`;

	return (
		<Wrapper>
			<Box>
				{adminNavigationConfig
					.filter((d) => checkAccess(d.access))
					.map((navigationSection) => (
						<React.Fragment key={navigationSection.name}>
							<NavigationSection
								to={getSectionLink(navigationSection)}
								selected={pathname === getSectionLink(navigationSection)}
								link={navigationSection.link}
							>
								<IconWrapper>
									{navigationSection.path ? (
										<img
											className={navigationSection.icon}
											src={navigationSection.path}
											width={20}
											height={20}
										/>
									) : (
										// <i className={navigationSection.icon} style={{ fontSize: 20, color: 'white' }} />
										<Icon name={navigationSection.icon} style={{ fontSize: 20, color: 'white' }} />
									)}
								</IconWrapper>
								<Hover className='hover'>{navigationSection.name}</Hover>
							</NavigationSection>
						</React.Fragment>
					))}
			</Box>
		</Wrapper>
	);
};

export default Navbar;
